// @flow

import store from "./store";
import diffs from "../diffs";
import { abortAll } from "../XhrComponentUtils";
import apiMethod from "../../api/apiMethod";
import { getAccountInfoCall, getBillingInfoCall } from "../../api/business";
import businessSubscriber from "../business/businessSubscriber";

import type { Userinfo } from "../../types/user";
import type { UserState } from "./reducers/user";
import {
  loadAccountInfo,
  clearAccountInfo,
  loadBillingInfo,
  clearBillingInfo,
  loadUsers,
  loadTeams,
  clearUsers,
  clearTeams
} from "./actions/business";

let currentToken = "";
let stopListen;
let xhrs = [];
let bUsers;
let bTeams;
let billingInfo = {};
let accountInfo = {};

const getUsers = () => {
  return apiMethod(
    "account_users",
    { auth: currentToken, withavatars: 1 },
    ret => {
      bUsers = ret.users;
    },
    { forceFresh: true }
  );
};

const getTeams = () => {
  return apiMethod(
    "account_teams",
    { auth: currentToken, showeveryone: 1, showlinks: 1 },
    ret => {
      bTeams = ret.teams;
    },
    { forceFresh: true }
  );
};

store.subscribe(() => {
  checkUser(currentUserState());
});

checkUser(currentUserState());

function checkUser(userState: UserState) {
  if (userState.token != currentToken) {
    if (currentToken) {
      console.log("stop listen");
      currentToken = "";
      userLogout();
      stopListen();
    }

    if (userState.logged && userState.userinfo.business) {
      console.log("go Listen");
      console.log("userState.logged", userState.logged);
      console.log("currentToken", currentToken);
      console.log("userState.token", userState.token);

      currentToken = userState.token;
      userLogin();
      listen();
    }
  }
}

function userLogin() {
  xhrs.push(getUsers());
  xhrs.push(getTeams());
  xhrs.push(getBillingInfoCall(ret => {
    billingInfo = ret;
  }));
  xhrs.push(getAccountInfoCall(ret => {
    accountInfo = ret;
  }));

  Promise.all(xhrs).then(() => {
    delete billingInfo.result;
    delete accountInfo.result;
    console.log("++++++++++++++++++++");
    console.log("bUsers", bUsers);
    console.log("bTeams", bTeams);
    console.log("billingInfo", billingInfo);
    console.log("accountInfo", accountInfo);

    store.dispatch(loadUsers(bUsers));
    store.dispatch(loadTeams(bTeams));
    store.dispatch(loadBillingInfo(billingInfo));
    store.dispatch(loadAccountInfo(accountInfo));

    xhrs = [];
    bUsers = [];
    bTeams = [];
    billingInfo = {};
    accountInfo = {};
  });
}

function userLogout() {
  abortAll(xhrs);
  store.dispatch(clearUsers());
  store.dispatch(clearTeams());
  store.dispatch(clearBillingInfo());
  store.dispatch(clearAccountInfo());
}

function currentUserinfo(): Userinfo | false {
  const user = currentUserState();
  return user.logged ? user.userinfo : false;
}

function currentUserState(): UserState {
  return store.getState().user;
}

function listen() {
  stopListen = businessSubscriber.listen(currentToken, event => {
    console.log("EVENTS>>>>>>>>>>>>>>>", event);
    if (event === "users") {
      xhrs.push(getUsers());
    } else if (event === "teams") {
      xhrs.push(getTeams());
    }

    if (xhrs.length !== 0) {
      Promise.all(xhrs).then(() => {
        if (bUsers.length !== 0) {
          store.dispatch(loadUsers(bUsers));
        }

        if (bTeams.length !== 0) {
          store.dispatch(loadTeams(bTeams));
        }

        xhrs = [];
        bUsers = [];
        bTeams = [];
      });
    }
  });
}
